import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.prototype.i18n = window.i18n;
Vue.use(VueAxios, axios);

Vue.component('login', require('./Login.vue').default);
Vue.component('input-group', require('../components/InputGroup.vue').default);

const app = new Vue({
    el: '#login'
});
